import React from "react";
import AppStrokeIcon, { type IAppNavIconProps } from "./AppStrokeIcon";

/** `inbox_inactive_icon.svg` (two chat bubbles). */
const InboxIcon: React.FC<IAppNavIconProps> = (props) => (
  <AppStrokeIcon {...props}>
    <path d="M17 9C17 12.87 13.64 16 9.5 16L8.57 17.12L8.02 17.78C7.55 18.34 6.65 18.22 6.34 17.55L5 14.6C3.18 13.32 2 11.29 2 9C2 5.13 5.36 2 9.5 2C12.52 2 15.13 3.67 16.3 6.07C16.75 6.96 17 7.95 17 9Z" />
    <path d="M22 12.86C22 15.15 20.82 17.18 19 18.46L17.66 21.41C17.35 22.08 16.45 22.21 15.98 21.64L14.5 19.86C12.08 19.86 9.92 18.79 8.57 17.12L9.5 16C13.64 16 17 12.87 17 9C17 7.95 16.75 6.96 16.3 6.07C19.57 6.82 22 9.58 22 12.86Z" />
    <path d="M7 9H12" />
  </AppStrokeIcon>
);

export default InboxIcon;
